import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pagination"
export default class extends Controller {
  static targets = ["item", "info"]
  static values  = { perPage: { type: Number, default: 6 }, page: { type: Number, default: 1 } }

  connect() {
    this.render()
  }

  prev() {
    if (this.pageValue > 1) {
      this.pageValue--
      this.render()
    }
  }

  next() {
    if (this.pageValue < this.totalPages) {
      this.pageValue++
      this.render()
    }
  }

  get totalPages() {
    return Math.ceil(this.itemTargets.length / this.perPageValue)
  }

  render() {
    const start = (this.pageValue - 1) * this.perPageValue
    const end   = start + this.perPageValue

    this.itemTargets.forEach((el, i) => {
      el.classList.toggle("d-none", i < start || i >= end)
    })

    if (this.hasInfoTarget) {
      this.infoTarget.textContent = `${this.pageValue} / ${this.totalPages}`
    }

    this.element.querySelectorAll("[data-action='pagination#prev']").forEach(btn => {
      btn.disabled = this.pageValue <= 1
    })
    this.element.querySelectorAll("[data-action='pagination#next']").forEach(btn => {
      btn.disabled = this.pageValue >= this.totalPages
    })
  }
}
